import React, { useState } from 'react';
import { MoreHorizontal } from 'react-feather';
import { Dropdown, Button } from 'app/seedly-component-library';

const PostCardWrapper = props => {
  const { disableMenu, menuOptions = [], buttonSize = 'md', testid } = props;

  const [showMenu, setShowMenu] = useState(false);

  return (
    <div
      className="card relative"
      onMouseEnter={() => setShowMenu(true)}
      onMouseLeave={() => setShowMenu(false)}
      data-testid={testid}
    >
      {!disableMenu && menuOptions.length > 0 && showMenu && (
        <div className="absolute right-4 top-3">
          <Dropdown
            items={menuOptions}
            handleSelectedItemchange={item => {
              item.selectedItem.onClick();
            }}
            menuAlign="right"
            button={
              <Button
                size={buttonSize}
                variant="ghost"
                data-testid="post-card-menu-options"
                icon={<MoreHorizontal />}
              />
            }
          />
        </div>
      )}
      {props.children}
    </div>
  );
};

export default PostCardWrapper;
